var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadingBalloonAnimation',{attrs:{"text":"Accessing flight..."}})}
var staticRenderFns = []

export { render, staticRenderFns }